import { render, staticRenderFns } from "./StatisticsContainer.vue?vue&type=template&id=cafb97d8&scoped=true&"
import script from "./StatisticsContainer.vue?vue&type=script&lang=js&"
export * from "./StatisticsContainer.vue?vue&type=script&lang=js&"
import style0 from "./StatisticsContainer.vue?vue&type=style&index=0&id=cafb97d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cafb97d8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VImg,VProgressLinear,VRow})
